import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row pt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-bold text-infoColor" }, "決議結果", -1)
const _hoisted_3 = { class: "justify-center pl-10" }
const _hoisted_4 = { class: "flex flex-col border-l-2" }
const _hoisted_5 = { class: "flex flex-row pt-2 items-center text-lg text-infoColor" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "px-5" }, " 決議日期 ", -1)
const _hoisted_7 = {
  key: 0,
  class: "font-black"
}
const _hoisted_8 = {
  key: 1,
  class: "text-warningColor"
}
const _hoisted_9 = { class: "flex flex-row pt-2 items-center text-lg text-infoColor" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "px-5" }, " 決議地點 ", -1)
const _hoisted_11 = {
  key: 0,
  class: "font-black"
}
const _hoisted_12 = {
  key: 1,
  class: "text-warningColor"
}
const _hoisted_13 = { class: "flex flex-row pt-2 items-center text-lg text-infoColor" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "px-5" }, " 受邀人員 ", -1)
const _hoisted_15 = { class: "font-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.event?.IsResolution == _ctx.ParamIsResolution.Done)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.datetimeFormat(_ctx.event?.StartUTCDateTime ?? new Date().toISOString()) + _ctx.dayjs( _ctx.event?.EndUTCDateTime ?? new Date().toISOString()).format("HH:mm")), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_8, " 會議已取消 "))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (_ctx.event?.IsResolution == _ctx.ParamIsResolution.Done)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.event?.Location), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_12, " 會議已取消 "))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.attendee?.map((a) => a.Name).join('；')), 1)
        ])
      ])
    ])
  ]))
}